import React from "react";
import { OrganizationDto } from "../../../common/service/server/dto/OrganizationDto";
import { OrganizationNameForm } from "./OrganizationNameForm";

export const OrganizationSettingsView = ({
  organization,
  updateOrganization,
}: {
  organization: OrganizationDto;
  updateOrganization(values: any): void;
}) => {
  return (
    <div>
      <div className={"org-settings"}>
        <OrganizationNameForm organization={organization} updateOrganization={updateOrganization} />
      </div>
    </div>
  );
};
